import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./components/index";
import "./styles/index.less";
import VueMeta from "vue-meta";
// import vueMetaInfo from "vue-meta-info";
Vue.use(VueMeta);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
